import AIAuthority from '../components/AIAuthority';

export default function AEODashboard() {
  return <AIAuthority />;
}
